/**
 * Pré-checagem: Previsto para hoje + App Go offline (>20 min com dia iniciado).
 * Retorno `blocked` = exige confirmação do usuário (não trava definitiva).
 */

import { getApiBaseUrl } from '../../../utils/apiConfig';

export const BOARD_DRAG_MSG_PREVISTO_GO_OFFLINE =
  'O técnico está sem comunicação há mais de 20 minutos e pode não receber esta atualização. Isso pode causar problemas de sincronização e afetar o funcionamento do aplicativo. Deseja realmente confirmar esta ação?';

/**
 * @param {{ orderIds: string[], targetSection: string, technicianId?: string|null }} opts
 * @returns {Promise<{ blocked: boolean, messages: string[] }>}
 */
export async function validateBoardDragPrevistoGoSync({ orderIds, targetSection, technicianId } = {}) {
  const ids = Array.isArray(orderIds)
    ? orderIds.map((x) => String(x || '').trim()).filter(Boolean)
    : [];
  const section = targetSection != null ? String(targetSection).trim() : '';
  if (ids.length === 0 || !section) {
    return { blocked: false, messages: [] };
  }
  const token = localStorage.getItem('authToken');
  try {
    const res = await fetch(`${getApiBaseUrl()}/api/board/orders/validate-previsto-go-sync`, {
      method: 'POST',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        orderIds: ids,
        targetSection: section,
        technicianId:
          technicianId != null && String(technicianId).trim() !== ''
            ? String(technicianId).trim()
            : null,
      }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.success) {
      return { blocked: false, messages: [] };
    }
    return {
      blocked: Boolean(data.blocked),
      messages: Array.isArray(data.messages) ? data.messages : [],
    };
  } catch (_err) {
    return { blocked: false, messages: [] };
  }
}
